import { Field } from 'factorial-form'

export const MINUTES_PER_HOUR = 60.0
const NO_MINUTES = 0
const MINIMUM_MINUTES_FOR_TWO_DIGITS = 10

export const formatProjectHours = (inputedMinutes: number | null | undefined) => {
  if (inputedMinutes === null || inputedMinutes === undefined || inputedMinutes === 0) return '0h'
  const hours = Math.floor(inputedMinutes / MINUTES_PER_HOUR) + 'h '
  const minutes =
    inputedMinutes % MINUTES_PER_HOUR < MINIMUM_MINUTES_FOR_TWO_DIGITS
      ? '0' + (inputedMinutes % MINUTES_PER_HOUR) + 'm'
      : (inputedMinutes % MINUTES_PER_HOUR) + 'm'
  const result = inputedMinutes % MINUTES_PER_HOUR === NO_MINUTES ? hours : hours + minutes
  return result
}

export const getMinutesFromTimeFormat = (timeFormat: Field) => {
  if (!timeFormat) return NO_MINUTES
  let [hours, minutes] = timeFormat.toString().split(':')
  if (hours === '--') hours = '0'
  if (minutes === '--') minutes = '0'
  return Number(hours) * MINUTES_PER_HOUR + Number(minutes)
}

export const getTimeFormatFromMinutes = (minutes: number, isEditMode: boolean) => {
  if (minutes === NO_MINUTES && !isEditMode) return '-'
  if (minutes === NO_MINUTES && isEditMode) return ''
  const hours = Math.floor(minutes / MINUTES_PER_HOUR)
  const minutesLeft = minutes % MINUTES_PER_HOUR
  const minutesString =
    minutesLeft < MINIMUM_MINUTES_FOR_TWO_DIGITS ? `0${minutesLeft}` : `${minutesLeft}`
  return `${hours}:${minutesString}`
}

// decimal hours like: 1.5, 2.5 will return 90mins, 150mins
export const getMinutesFromDecimalHours = (decimalHours: number) => {
  return Math.round(decimalHours * MINUTES_PER_HOUR)
}

// minutes like: 90mins, 150mins will return 1.5hours, 2.5hours
export const getDecimalHoursFromMinutes = (minutes: number): number => {
  return Number((minutes / MINUTES_PER_HOUR).toFixed(2))
}
